export const VerificationStatus = {
    pending: "Verification pending",
    successful: "Verification successful",
    failed: "Verification failed",
    notApplicable: "Verification not applicable"
}